import { useNavigate, NavLink } from 'react-router-dom';
import { LayoutDashboard, Building, Users, Mail, Package, SendHorizonal, LogOut, FileCode2, Activity } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Layout({ user, setUser, children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard', roles: ['superadmin', 'companyadmin', 'companyuser'] },
    { path: '/companies', icon: Building, label: 'Companies', roles: ['superadmin'] },
    { path: '/users', icon: Users, label: 'Users', roles: ['superadmin', 'companyadmin'] },
    { path: '/mail-configs', icon: Mail, label: 'Mail Configs', roles: ['superadmin', 'companyadmin'] },
    { path: '/batches', icon: Package, label: 'File Batches', roles: ['superadmin', 'companyadmin', 'companyuser'] },
    { path: '/send-batches', icon: SendHorizonal, label: 'Send Batches', roles: ['superadmin', 'companyadmin', 'companyuser'] },
    { path: '/api-docs', icon: FileCode2, label: 'API Docs', roles: ['superadmin'] },
    { path: '/audit-logs', icon: Activity, label: 'Audit Logs', roles: ['superadmin'] },
  ];

  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
      <nav className="border-b p-4" style={{background: 'rgba(255, 255, 255, 0.98)', backdropFilter: 'blur(12px)', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'}}>
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
              <SendHorizonal className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <div className="text-xs font-semibold uppercase tracking-wide text-blue-600">Picodix</div>
              <h1 className="text-2xl font-bold text-gray-800" style={{fontFamily: 'Space Grotesk'}}>BatchMailer</h1>
            </div>
          </div>
          <div className="flex items-center gap-4">
            {user && navItems.filter(item => item.roles.includes(user.role)).map(item => (
              <NavLink 
                key={item.path} 
                to={item.path}
                className={({isActive}) => `flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-colors ${isActive ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'}`}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            ))}
            {user && (
              <div className="hidden xl:flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2">
                <div className="text-right">
                  <div className="text-sm font-semibold text-gray-800">{user.email}</div>
                  <div className="text-xs text-gray-500">{user.company_name || 'No company'} - {user.role}</div>
                </div>
              </div>
            )}
            <Button variant="ghost" onClick={handleLogout} size="sm" className="text-gray-700 hover:bg-red-50 hover:text-red-600" data-testid="logout-button">
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </nav>
      <div className="max-w-7xl mx-auto p-6">
        {children}
      </div>
    </div>
  );
}
